import AboutRoutes from './about'

import UserAbout from '@/pages/user/pages/about'
import UserApply from '@/pages/user/pages/apply'
import UserBox from '@/pages/user/pages/box'
import UserFlight from '@/pages/user/pages/flight'

const ROOT = ''
export default {
  routes: [
    {
      path: ROOT + 'about',
      name: 'UserAbout',
      meta: {
        group: 'user',
        requireAuth: true,
        icon: {
          default: ['fal', 'user'],
          active: ['fas', 'user']
        },
        label: 'お客様情報',
        permit: 'about'
      },
      component: UserAbout,
      redirect: { name: 'UserAboutBasic' },
      children: AboutRoutes.routes
    },
    {
      path: ROOT + 'apply',
      name: 'UserApply',
      meta: {
        group: 'user',
        requireAuth: true,
        icon: {
          default: ['fal', 'file-signature'],
          active: ['fas', 'file-signature']
        },
        label: 'お申込み',
        permit: 'apply'
      },
      component: UserApply
    },
    {
      path: ROOT + 'box',
      name: 'UserBox',
      meta: {
        group: 'user',
        requireAuth: true,
        icon: {
          default: ['fal', 'cloud'],
          active: ['fas', 'cloud']
        },
        label: '書類',
        permit: 'developer'
      },
      component: UserBox
    },
    {
      path: ROOT + 'flight',
      name: 'UserFlight',
      meta: {
        group: 'user',
        requireAuth: true,
        icon: {
          default: ['fal', 'plane'],
          active: ['fas', 'plane']
        },
        label: 'フライト',
        permit: 'developer'
      },
      component: UserFlight
    }
  ]
}
